export var MutationType;
(function (MutationType) {
    MutationType["Added"] = "added";
    MutationType["Changed"] = "changed";
    MutationType["Removed"] = "removed";
})(MutationType || (MutationType = {}));
